// extracted by mini-css-extract-plugin
module.exports = {"DeliveryOrder":"DeliveryOrder_DeliveryOrder__3yM-e"};